import { Link } from "react-router-dom";
import {
  Facebook,
  Instagram,
  MapPin,
  Mail,
  Phone,
} from "lucide-react";
import { DynamicLogo } from '../DynamicLogo';

const navigation = {
  main: [
    { name: "Início", href: "/" },
    { name: "Serviços", href: "/servicos" },
    { name: "Produtos", href: "/produtos" },
    { name: "PMOC", href: "/pmoc" },
    { name: "Contato", href: "/contato" },
  ],
  social: [
    {
      name: "Facebook",
      href: "https://www.facebook.com/arcgel.ar/",
      icon: Facebook,
    },
    {
      name: "Instagram",
      href: "https://www.instagram.com/arcgel.ar",
      icon: Instagram,
    },
  ],
};

export default function Footer() {
  return (
    <footer className="relative bg-slate-950/95 border-t border-cyan-400/20 backdrop-blur-xl shadow-2xl" aria-labelledby="footer-heading">
      {/* Overlay para garantir tom escuro */}
      <div className="absolute inset-0 bg-slate-950/90 backdrop-blur-sm"></div>
      
      <h2 id="footer-heading" className="sr-only">
        Footer
      </h2>
      <div className="container py-12 lg:py-16 relative z-10">
        <div className="flex flex-col lg:flex-row lg:justify-between gap-12 lg:gap-16">
          {/* Logo e social */}
          <div className="flex flex-col items-center lg:items-start gap-6">
            <Link to="/" className="flex items-center group">
              <DynamicLogo 
                alt="Arcgel" 
                className="h-10 w-auto drop-shadow-lg transition-transform group-hover:scale-105"
                fallback={
                  <div className="h-10 w-24 bg-blue-600 rounded flex items-center justify-center text-white font-bold text-sm">
                    ARCGEL
                  </div>
                }
              />
            </Link>
            <p className="text-base text-blue-100/80 text-center lg:text-left max-w-xs">
              Soluções completas em climatização para sua casa ou empresa.
            </p>
            <div className="flex gap-4 mt-2">
              {navigation.social.map((item) => (
                <a
                  key={item.name}
                  href={item.href}
                  className="glass border border-primary/20 rounded-full p-2 text-blue-100 hover:text-white hover:border-accent transition-all duration-200 shadow-lg hover:scale-110 animate-glassPulse"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <span className="sr-only">{item.name}</span>
                  <item.icon className="h-6 w-6" aria-hidden="true" />
                </a>
              ))}
            </div>
          </div>
          {/* Navegação e contato */}
          <div className="flex flex-col sm:flex-row gap-10 lg:gap-20 justify-center lg:justify-end flex-1">
            <div>
              <h3 className="text-base font-semibold text-primary mb-3 tracking-wide uppercase">Navegação</h3>
              <ul role="list" className="space-y-2">
                {navigation.main.map((item) => (
                  <li key={item.name}>
                    <Link
                      to={item.href}
                      className="text-base text-blue-100/80 hover:text-accent transition-colors font-medium"
                    >
                      {item.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <h3 className="text-base font-semibold text-primary mb-3 tracking-wide uppercase">Contato</h3>
              <ul role="list" className="space-y-2">
                <li>
                  <a
                    href="https://goo.gl/maps/your-address"
                    className="flex items-center text-base text-blue-100/80 hover:text-accent transition-colors"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <MapPin className="mr-2 h-5 w-5 opacity-80" />
                    <span>Av.Senador Dantas, 225, Santos/SP</span>
                  </a>
                </li>
                <li>
                  <a
                    href="tel:+5513991028221"
                    className="flex items-center text-base text-blue-100/80 hover:text-accent transition-colors"
                  >
                    <Phone className="mr-2 h-5 w-5 opacity-80" />
                    <span>(13) 99102-8221</span>
                  </a>
                </li>
                <li>
                  <a
                    href="mailto:contato@arcgel.com.br"
                    className="flex items-center text-base text-blue-100/80 hover:text-accent transition-colors"
                  >
                    <Mail className="mr-2 h-5 w-5 opacity-80" />
                    <span>contato@arcgel.com.br</span>
                  </a>
                </li>
                <li className="mt-4">
                  <Link
                    to="/admin/login"
                    className="text-xs text-slate-500 hover:text-cyan-400 transition-colors"
                  >
                    Área Administrativa
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="mt-12 border-t border-primary/20 pt-8 text-center">
          <p className="mt-6 text-center text-xs text-blue-300 flex flex-col gap-1 items-center">
            <span>&copy; {new Date().getFullYear()} Arcgel. Todos os direitos reservados.</span>
            <span className="text-[0.75rem] text-cyan-300/80">
              Desenvolvido por <a href="https://coddar.com.br" target="_blank" rel="noopener noreferrer" className="underline hover:text-cyan-200 transition-colors">Coddar Digital</a>
            </span>
          </p>
        </div>
      </div>
    </footer>
  );
}
